export const enUS = {
  'page.login.login': 'Login'
}

export default enUS
